export default __webpack_public_path__ + "static/scroll-down-hint-150b079823464762dcc423908389b99c.png";